import { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import MobileTopBar from './MobileTopBar';
import HomePage from './HomePage';
import AlbumPage from './AlbumPage';
import PlayerBar from './PlayerBar';
import MobileNowPlayingSheet from './MobileNowPlayingSheet';
import EmberCanvas from './effects/EmberCanvas';

export default function Shell() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="app-root">
      <EmberCanvas />
      <MobileTopBar onOpenSidebar={() => setSidebarOpen(true)} />
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <main className="main">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/album/:id" element={<AlbumPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <p className="disclaimer">
          Armagedify is a fan-made parody website created for a private event. It is not affiliated
          with, endorsed by, or associated with Spotify AB or any of its products. All design
          similarities are purely satirical and for entertainment purposes only.
        </p>
      </main>
      <PlayerBar />
      <MobileNowPlayingSheet />
    </div>
  );
}
